<template>
  <div class="c360-footer d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <slot name="logo">
        <img
          :class="!footerLogo ? 'c360-footer-image-inverted' : ''"
          :src="currentLogo"
          :style="{
            maxWidth: '180px',
            maxHeight: '40px',
          }"
          alt="Logo"
        />
      </slot>
      <slot name="extension" />
    </div>
    <p class="mb-0">&COPY;{{ year }} {{ copyright }}. All Rights Reserved.</p>
    <a
      v-if="showEmail"
      :href="helpCenterUrl"
      target="_blank"
      class="white--text font-weight-bold text-decoration-none mb-0"
    >
      Need help?
    </a>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { C360Ability } from '../../../shared/abilities';
  import { usePortalLink } from '../../../shared/portal-link';
  import { getHasAccessToSubmitRequest } from '../model';

  export default Vue.extend({
    name: 'C360Footer',

    inject: ['$c360', '$can', '$accessTokenProvider'],

    data() {
      return {
        hasAccessToRequestPage: false,
      };
    },

    async beforeMount() {
      const token = this.$accessTokenProvider();
      this.hasAccessToRequestPage = await getHasAccessToSubmitRequest(token);
    },

    computed: {
      year() {
        return new Date().getFullYear();
      },
      footerLogo() {
        return this.$c360.footerLogo;
      },
      mainLogo() {
        return this.$c360.logo;
      },
      currentLogo() {
        return this.footerLogo ? this.footerLogo : this.mainLogo;
      },
      copyright() {
        return this.$c360.copyright;
      },
      helpCenterUrl() {
        const { link } = usePortalLink(this.$c360.portalName);

        const destinationLink = this.hasAccessToRequestPage ? 'help/request' : 'help';
        return `${link}/${destinationLink}`;
      },
      showEmail() {
        return this.$can(C360Ability.SeeEmailInTheFooter);
      },
    },
  });
</script>

<style scoped>
  .c360-footer {
    background: black;
    font-family: var(--c360-font);
    font-size: 12px;
    color: white !important;
    width: 100%;
  }
  .c360-footer-image-inverted {
    filter: grayscale(1) invert(89%) brightness(135%);
  }
</style>
